// Library methods
import { useTheme } from "@mui/material/styles";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography, { TypographyProps } from "@mui/material/Typography";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { InfoIcon } from "src/assets/icons";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type TitleWithTooltipType = {
  title: string;
  tooltip: string | JSX.Element;
  titleStyle?: TypographyProps["sx"];
  tooltipStyle?: TooltipProps["sx"];
  tooltipPlacement?: TooltipProps["placement"];
};

const TitleWithTooltip = ({
  title,
  tooltip,
  titleStyle,
  tooltipStyle,
  tooltipPlacement = "bottom",
}: TitleWithTooltipType) => {
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);

  const defaultTitleStyle = {
    color: onSurface,
    fontSize: "16px",
    fontWeight: 500,
  };
  const defaultTooltipStyle = {
    color: onSurface,
    height: "16px",
    width: "16px",
  };

  return (
    <Grid item display="flex" alignItems="center">
      <Typography
        sx={{
          ...defaultTitleStyle,
          ...titleStyle,
          marginRight: tooltip ? "4px" : "0px",
        }}
      >
        {title}
      </Typography>
      {tooltip && (
        <Tooltip title={tooltip} placement={tooltipPlacement}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              ...defaultTooltipStyle,
              ...tooltipStyle,
            }}
          >
            <InfoIcon />
          </Box>
        </Tooltip>
      )}
    </Grid>
  );
};

export default TitleWithTooltip;
